<template>
  <transition name="fade" mode="out-in" appear>
    <div class="new-modal-wrapper" v-if="isVisible">
      <div class="new-modal" :class="`new-modal--${size}`">
        <header v-if="title">
          <p>
            <strong>{{ title }}</strong>
          </p>
        </header>

        <main>
          <slot></slot>
        </main>

        <footer>
          <button class="btn btn-close" @click.prevent="closeModal(false)">
            <span class="mck">F</span>
            Затвори
          </button>
          <button
            v-if="!onlyCancel"
            class="btn btn-new"
            :disabled="getLoading"
            type="submit"
            value="Submit"
            @click.prevent="$emit('save')"
          >
            <span class="mck">Y</span>
            Запиши
          </button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["title", "size", "onlyCancel"],
  computed: {
    ...mapGetters(["getLoading"]),
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    handleKeydown(e) {
      if (e.key === "Escape") {
        this.closeModal();
      }
    },
  },
  mounted() {
    setTimeout(() => {
      document.body.classList.add("no-scroll");
    }, 100);

    this.$nextTick(() => {
      this.isVisible = true;
    }, 50);
    window.addEventListener("keydown", this.handleKeydown);
  },
  destroyed() {
    document.body.classList.remove("no-scroll");
    window.removeEventListener("keydown", this.handleKeydown);
  },
};
</script>

<style scoped lang="scss">
.new-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  cursor: initial;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;

  .new-modal {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 0 99px 0 #00000087;
    position: relative;
    overflow: auto;
    padding: 10px 20px 0;
    max-width: 620px;
    width: calc(100% - 20px);

    &.new-modal--big {
      max-width: 1550px;
    }

    &.new-modal--medium {
      max-width: 440px;
    }

    &.new-modal--small {
      max-width: fit-content;
    }

    > header {
      align-items: center;
      border-top-left-radius: inherit;
      border-top-right-radius: inherit;
      display: flex;
      justify-content: space-between;
      padding: 10px;
      user-select: none;

      p {
        font-size: 20px;
      }
    }

    > main {
      display: flex;
      flex-direction: column;
      gap: 8px;
      overflow: auto;
      height: fit-content;
      max-height: 80vh;
    }

    > footer {
      border-bottom-left-radius: inherit;
      border-bottom-right-radius: inherit;
      display: flex;
      gap: 10px;
      justify-content: center;
      padding: 20px 10px;

      .btn {
        margin: initial;
      }
    }
  }
}

.modal-enter-active,
.modal-leave-active {
  transition: 0.3s all;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.appear-enter-active,
.appear-leave-active {
  transition: 0.3s all;
}

.appear-enter-from,
.appear-leave-to {
  opacity: 0;
  transform: scale(0);
}
@media screen and (max-width: 1000px) {
  .new-modal-wrapper {
    .new-modal {
      > main {
        max-height: 60vh;
      }
    }
  }
}
</style>
